var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_45_730_00000027582833392706674950000003951662928070793369_);}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 7.2,
    y: 4.6,
    width: 11.2,
    height: 16
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 7.2,
    y: 4.6,
    width: 11.2,
    height: 16,
    id: "mask0_45_730_00000027582833392706674950000003951662928070793369_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.6,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.2,20.6v-2h-3v-1h2v-10h-2v-1h3v-2h1v2h2.2v-2h1v2c0.9,0.1,1.6,0.4,2.2,1c0.6,0.6,0.8,1.3,0.8,2.3 c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1c0.7,0.2,1.2,0.6,1.5,1.1c0.4,0.5,0.6,1.2,0.6,1.9c0,0.9-0.3,1.7-0.9,2.3 c-0.6,0.6-1.4,0.9-2.3,0.9h-0.8v2h-1v-2h-2.2v2H10.2z M10.2,12.1h3.9c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-1,0.6-1.6 c0-0.7-0.2-1.2-0.6-1.6c-0.4-0.4-1-0.6-1.6-0.6h-3.9V12.1z M10.2,17.6h4.9c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-1,0.6-1.6 s-0.2-1.2-0.6-1.6c-0.4-0.4-1-0.6-1.6-0.6h-4.9V17.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoIcon);
export default __webpack_public_path__ + "static/media/crypto-icon.2ae1f15a643077e0b1c174c6906e922a.svg";
export { ForwardRef as ReactComponent };